export default class EnterpriseUpdateLimitsRequest {
  public documentSize;
  public pagesPerDocument;

  constructor(options) {
    if ((options.documentSize === '') || (options.documentSize === null)) {
      this.documentSize = null;
    } else {
      this.documentSize = parseInt(options.documentSize, 10);
    }

    if ((options.pagesPerDocument === '') || (options.pagesPerDocument === null)) {
      this.pagesPerDocument = null;
    } else {
      this.pagesPerDocument = parseInt(options.pagesPerDocument, 10);
    }
  }
}
